import { Printer } from "lucide-react";

import { Link } from "../components/Link";
import { HandoutPageRule, HandoutSheet } from "../manual/HandoutSheet";

/** 선생님이 인쇄해 학생에게 나눠 주는 A4 한 장 안내문. */
export const StudentManualPage = () => (
  <div className="canvaschool-handout">
    <HandoutPageRule />
    <div className="ch-toolbar">
      <Link to="/manual">← 이용 매뉴얼</Link>
      <button
        type="button"
        className="canvaschool-btn-primary"
        onClick={() => window.print()}
      >
        <Printer size={18} aria-hidden="true" />
        인쇄하기
      </button>
    </div>

    <HandoutSheet />
  </div>
);
